import silu from '../assets/silu.png';
import whats from '../assets/whats.png';

const Avatar = ({ user, currentChat }) => {
  return ( 
    <div // Reduced width and height, adjusted padding and shadow
      className={`flex flex-col items-center justify-center text-center border card w-28 h-28 shadow-md rounded-lg cursor-pointer transition-all duration-200 ease-in-out hover:shadow-lg hover:scale-105
        ${user.channel_id == currentChat.channel_id
          ? "bg-indigo-50 border-indigo-400" // Simplified background, stronger border for active
          : "bg-white border-gray-200" // Standard background and border
        }`}
    >
      <div className="relative"> {/* Removed mt-2 to bring avatar closer to top */}
        <img
          className="object-cover inline-block h-10 w-10 rounded-full border-2 border-white shadow-sm" // Reduced avatar size
          src={user.category == 1 ? silu : whats}
          alt="User Avatar"
        />
        <div
          className={`absolute -top-1 -right-1 h-4 w-4 flex items-center justify-center text-white text-[10px] font-semibold rounded-full ${ // Smaller, repositioned badge
            user.unread > 0 ? "bg-red-500" : "hidden" // Hide badge if no unread messages
          }`} // Removed bg-gray-400 for 0 unread, made it hidden instead
        >
          {user.unread}
        </div>
      </div>
      <div className="mt-2 w-24"> {/* Reduced margin-top and width for name container */}
        <p
          className="text-xs font-medium text-gray-700 group-hover:text-gray-800 truncate" // Reduced font size for name
          title={user.name}
        >
          {user.name}
        </p>
      </div>
    </div>
  );
};

export default Avatar;
